let DEFINE_KEY = {
    ALERT_CONFIG: {
        SHOW_ALERT_CLS_TYPE: {
            "warning": {
                cls: "msgWarning",
                iCls: "iconfont icon-info-dialog"
            },
            "error": {
                cls: "msgError",
                iCls: "iconfont icon-close-bg"
            },
            "default": {
                cls: "msgWarning",
                iCls: "iconfont icon-info-dialog"
            }
        },
        ALERT_CLOSE_TIME: 2000
    }
}
let LeCompTool = {
    _idSeed: {
        id: 90000,
        newId: () => {
            return LeCompTool._idSeed.id++;
        }
    }
}
let _le_alert = {
    getTipDom: function (msg) {
        let zIndex = LeCompTool._idSeed.newId();
        let html = `
              <div style='z-index:${zIndex};top:50%;opacity:0;' class='le_alert content' tag="le_alert_show_tip">
                <div class='tipBox' style='opacity:1;background: rgba(0,0,0,0.5);'>
                  <p>${msg}</p>
                </div>
              </div>
            `;
        return html
    },
    showTip: function (msg) {
        $("body").append(this.getTipDom(msg));
        $("[tag='le_alert_show_tip']").animate({
            top: '50%',
            opacity: 1
        }, 500, () => {
            setTimeout(() => {
                $("[tag='le_alert_show_tip']").animate({
                    top: '50%',
                    opacity: 0,
                    'z-index': 0
                }, 500, () => {
                    $("[tag='le_alert_show_tip']").remove();
                })
            }, DEFINE_KEY.ALERT_CONFIG.ALERT_CLOSE_TIME)
        })
    },
    getMessageDom(type, msg) {
        let zIndex = LeCompTool._idSeed.newId();
        if (!type) {
            type = "default";
        }
        if (!msg) {
            msg = "NULL!";
        }
        let res = DEFINE_KEY.ALERT_CONFIG.SHOW_ALERT_CLS_TYPE[type];
        if (!res) {
            res = DEFINE_KEY.ALERT_CONFIG.SHOW_ALERT_CLS_TYPE["default"];
        }
        let html = `
          <div class='dialog_mask' style='z-index:${zIndex}' tag="le_alert_show_message">
            <div style='z-index:${zIndex};top:50%;opacity:0;' class='le_alert content'>
              <div class='msgBox ${res.cls}' style='opacity:1'>
                <i class='left ${res.iCls}'></i>
                <p>${msg}</p>
                <i tag='del' class='right iconfont icon-close-border closeBtn'></i>
              </div>
            </div>
          </div>
          `
        return html;
    },
    showMessage: function (type, msg) {
        $("body").append(this.getMessageDom(type, msg));
        $("[tag='le_alert_show_message']").find(".le_alert").animate({
            top: '50%',
            opacity: 1
        }, 500)
        $("[tag='le_alert_show_message']").on("click", "i[tag=del]", function () {
            $("[tag='le_alert_show_message']").remove();
        })

    },
    getContentDom(obj) {
        let html = "";
        let icon = ""
        let res = ""
        if (obj.type) {
            res = DEFINE_KEY.ALERT_CONFIG.SHOW_ALERT_CLS_TYPE[obj.type] || "";
            icon = `<i class='${res.iCls} ${res.cls}'></i>`
        }
        if (obj.content) {
            html = `
            <h5>${obj.title}</h5>
            <div class="content">${obj.content}</div>
          `;
        } else {
            html = `<h5 class="le_align_center">${icon}${obj.title}</h5>`;
        }
        return html
    },
    getButtonDom(obj) {
        let btn = {
            cancel: "",
            confirm: ""
        }
        if (obj.cancelText) {
            btn.cancel = `<span class="btn cancel" tag="le_show_confirm_close">${obj.cancelText || ""}</span>`
        }
        if (obj.confirmText) {
            btn.confirm = `<span class="btn confirm" tag="le_show_confirm_ok">${obj.confirmText || ""}</span>`
        }
        return btn
    },
    getConfirmDom(obj) {
        let zIndex = LeCompTool._idSeed.newId();
        let html = `
          <div style="z-index:${zIndex}" class="le_alert MsgAlertBox" tag="le_alert_show_confirm">
            <div class="Alertcontent">
              <i tag="le_show_confirm_close" class="iconfont icon-close-border le_show_confirm_close"></i>
              <div class="msgContent clearfix">${this.getContentDom(obj)}
                <div class="alert_btnGroup">
                  ${_le_alert.getButtonDom(obj).cancel}
                  ${_le_alert.getButtonDom(obj).confirm}
                </div>
            </div>
          </div>
        `
        return html
    },
    showConfirm: function (obj) {
        $("body").append(this.getConfirmDom(obj));
        $("[tag='le_alert_show_confirm']").show();
        $("body").off("click", "i[tag=le_show_confirm_close]").on("click", "i[tag=le_show_confirm_close]", function () {
            $("[tag='le_alert_show_confirm']").remove();
        })
        $("body").off("click", 'span[tag=le_show_confirm_close]').on("click", "span[tag=le_show_confirm_close]", function () {
            $("[tag='le_alert_show_confirm']").remove();
            obj.cancel && obj.cancel();
        })
        $("body").off("click", 'span[tag=le_show_confirm_ok]').on("click", "span[tag=le_show_confirm_ok]", function () {
            obj.confirm && obj.confirm();
            $("[tag='le_alert_show_confirm']").remove();
        })
    }
}

export default _le_alert;